import { Card, Col, Row } from "antd";
import React, { useState } from "react";
import {
  Form,
  Input,
  DatePicker,
  Radio,
  Checkbox,
  Select,
  Button,
  Typography,
} from "antd";
import FilterContainer from "../../../../components/common/FilterContainer";
import PageHeading from "../../../../components/common/PageHeading";
import MultiSelect from "../../../../components/common/MultiSelect";
const { Text, Title } = Typography;

const SendOwnerPacket = () => {
  const [selectedValue, setSelectedValue] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };

  const handleSearch = (e) => {
    setIsVisible(true);
  };

  const columns = [
    {
      title: "Name",
      dataIndex: "name",
      render: (text) => <a>{text}</a>,
    },
    {
      title: "Age",
      dataIndex: "age",
    },
    {
      title: "Address",
      dataIndex: "address",
    },
  ];
  const data = [
    {
      key: "1",
      name: "John Brown",
      age: 32,
      address: "New York No. 1 Lake Park",
    },
    {
      key: "2",
      name: "Jim Green",
      age: 42,
      address: "London No. 1 Lake Park",
    },
    {
      key: "3",
      name: "Joe Black",
      age: 32,
      address: "Sydney No. 1 Lake Park",
    },
    {
      key: "4",
      name: "Disabled User",
      age: 99,
      address: "Sydney No. 1 Lake Park",
    },
  ];
  return (
    <>
      <PageHeading heading="Send Owner Packets" />
      <Row>
        <FilterContainer
          heading={"Enter dates and any other information, then click Search."}
        >
          <Col span={20} offset={4}>
            <Form
              labelCol={{
                span: 4,
              }}
              layout="horizontal"
              style={{
                maxWidth: 800,
              }}
            >
              <Form.Item
                label="From"
                rules={[
                  {
                    required: true,
                  },
                  {
                    type: "url",
                    warningOnly: true,
                  },
                  {
                    type: "string",
                    min: 6,
                  },
                ]}
              >
                <Radio.Group onChange={handleRadioChange} value={selectedValue}>
                  <Radio value={1} name="from"></Radio>
                  <DatePicker />
                  <Form.Item>
                    <Radio value={2} name="to">
                      From the last time the packet was created
                    </Radio>
                  </Form.Item>
                </Radio.Group>
              </Form.Item>
              <Form.Item
                label="To"
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker />
                <Form.Item>
                  <Checkbox>
                    Only Owners with an Owner Payment in the date range
                    <i
                      className="fa-solid fa-circle-question"
                      style={{ color: "#3179cd", marginLeft: "5px" }}
                    ></i>
                  </Checkbox>
                </Form.Item>
              </Form.Item>
              <Form.Item name="Owners" label="Owners">
                <MultiSelect options={["test", "test2", "test3"]} />
              </Form.Item>
              <Form.Item name="Properties" label="Properties">
                <MultiSelect
                  options={["property1", "property2", "property3"]}
                  placeholder="Search by property, group, portfolio"
                />
              </Form.Item>
              <Col offset={4}>
                <Form.Item name="Properties">
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={[
                      {
                        value: "1",
                        label: "Show Active Properties",
                      },
                      {
                        value: "2",
                        label: "Show Hidden Properties",
                      },
                      {
                        value: "3",
                        label: "Show All Properties",
                      },
                    ]}
                  />
                </Form.Item>
              </Col>
              <Col>
                <Form.Item label="Included Reports" name="includeProperties">
                  <Select
                    showSearch
                    placeholder="Search to Select"
                    optionFilterProp="children"
                    filterOption={(input, option) =>
                      (option?.label ?? "").includes(input)
                    }
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    options={[
                      {
                        value: "1",
                        label: "Show Active Properties",
                      },
                      {
                        value: "2",
                        label: "Show Hidden Properties",
                      },
                      {
                        value: "3",
                        label: "Show All Properties",
                      },
                    ]}
                  />
                </Form.Item>
                <Col offset={4}>
                  <Button type="primary" onClick={handleSearch}>
                    Search
                  </Button>
                </Col>
              </Col>
            </Form>
          </Col>
        </FilterContainer>
      </Row>
      {isVisible && (
        <>
          <Row style={{ marginBottom: "20px" }}>
            <Col span={24}>
              <Title level={4}>Search Results</Title>
              <Text type="secondary">
                Packets for Email and Print are separated based on the Owner
                Packet settings for each owner.
              </Text>
            </Col>
          </Row>

          <Row>
            <Col span={8}>
              <Card style={{ borderRadius: "1px", textAlign: "center" }}>
                <p style={{ fontSize: "20px" }}>3</p>
                <Text type="secondary">Owners</Text>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ borderRadius: "1px", textAlign: "center" }}>
                <p style={{ fontSize: "20px" }}>3</p>
                <Text type="secondary">PACKETS FOR EMAIL</Text>
              </Card>
            </Col>
            <Col span={8}>
              <Card style={{ borderRadius: "1px", textAlign: "center" }}>
                <p style={{ fontSize: "20px" }}>3</p>
                <Text type="secondary">PACKETS FOR PRINT</Text>
              </Card>
            </Col>
          </Row>

          <Row>
            <Col span={24} style={{ marginTop: "20px" }}>
              <Form layout="vertical">
                <Form.Item label="Email and Publish to Owner Portal">
                  <a href="/viewPackects">Preview Packets</a>
                  <br />
                  <Button type="primary" style={{ marginTop: "10px" }}>
                    {" "}
                    Email 2 Packetes
                  </Button>
                </Form.Item>
              </Form>
            </Col>
          </Row>

          <Row>
            <Col span={10} style={{ marginTop: "10px" }}>
              <Form layout="vertical">
                <Form.Item label="Print and Publish to Owner Portal">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Button type="primary" style={{ marginTop: "10px" }}>
                      Email 0 Packetes
                    </Button>
                    <Button style={{ marginTop: "10px" }}>
                      Print 0 Envelopes
                    </Button>
                    <Button style={{ marginTop: "10px" }}>Print 0 label</Button>
                  </div>
                </Form.Item>
              </Form>
            </Col>
          </Row>
        </>
      )}
      <div className="RightSidebar"></div>
    </>
  );
};

export default SendOwnerPacket;
